export const LIST_FTL_COSTS = "LIST_FTL_COSTS"
export const STORE_FTL_COSTS = "STORE_FTL_COSTS"

export const LIST_SHIPPING_COSTS = "LIST_SHIPPING_COSTS"
export const STORE_SHIPPING_COSTS = "STORE_SHIPPING_COSTS"